import axios from "axios";
import { Caja, TamanoCaja, SocioCaja, CajaPersona } from "../types/caja.tsx";

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

const auth = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const obtenerTamanos = async (token: string) => {
  const { data } = await axios.get<TamanoCaja[]>(
    `${base}/cajas/tamanos`,
    auth(token)
  );
  return data;
};

export const crearTamano = async (
  payload: Partial<TamanoCaja>,
  token: string
) => {
  const { data } = await axios.post<TamanoCaja>(
    `${base}/cajas/tamanos`,
    payload,
    auth(token)
  );
  return data;
};

export const actualizarTamano = async (
  id: number,
  payload: Partial<TamanoCaja>,
  token: string
) => {
  const { data } = await axios.put<TamanoCaja>(
    `${base}/cajas/tamanos/${id}`,
    payload,
    auth(token)
  );
  return data;
};

export const eliminarTamano = async (id: number, token: string) => {
  await axios.delete(`${base}/cajas/tamanos/${id}`, auth(token));
};

export const obtenerCajas = async (
  params: Record<string, any>,
  token: string
) => {
  const { data } = await axios.get<{ items: Caja[]; total: number }>(
    `${base}/cajas`,
    { ...auth(token), params }
  );
  return data;
};

export const obtenerCaja = async (id: number, token: string) => {
  const { data } = await axios.get<Caja>(`${base}/cajas/${id}`, auth(token));
  return data;
};

export const crearCaja = async (
  payload: Partial<Caja> & {
    titulares?: Partial<CajaPersona>[];
    autorizados?: Partial<CajaPersona>[];
  },
  token: string
) => {
  const { data } = await axios.post<Caja>(
    `${base}/cajas`,
    payload,
    auth(token)
  );
  return data;
};

export const actualizarCaja = async (
  id: number,
  payload: Partial<Caja>,
  token: string
) => {
  const { data } = await axios.put<Caja>(
    `${base}/cajas/${id}`,
    payload,
    auth(token)
  );
  return data;
};

export const eliminarCaja = async (id: number, token: string) => {
  await axios.delete(`${base}/cajas/${id}`, auth(token));
};

export const obtenerSociosDeCaja = async (cajaId: number, token: string) => {
  const { data } = await axios.get<SocioCaja[]>(
    `${base}/cajas/${cajaId}/socios`,
    auth(token)
  );
  return data;
};

export const obtenerCajasDeSocio = async (
  socioId: string | number,
  token: string
) => {
  const { data } = await axios.get<Caja[]>(
    `${base}/cajas/socio/${socioId}`,
    auth(token)
  );
  return data;
};

export const obtenerCofresVencidos = async (token: string) => {
  const { data } = await axios.get<any[]>(`${base}/cajas/cofres/vencidos`, auth(token));
  return data;
};

export const obtenerCofresSocioMirror = async (
  socioId: string | number,
  token: string,
  limit = 50
) => {
  const { data } = await axios.get<any>(
    `${base}/cajas/cofres/socio/${socioId}`,
    { ...auth(token), params: { limit } }
  );
  return data;
};

export const asignarSocioACaja = async (
  payload: Partial<SocioCaja>,
  token: string
) => {
  const { data } = await axios.post<SocioCaja>(
    `${base}/cajas/asignar`,
    payload,
    auth(token)
  );
  return data;
};

export const actualizarSocioCaja = async (
  socioCajaId: number,
  payload: Partial<SocioCaja>,
  token: string
) => {
  const { data } = await axios.put<SocioCaja>(
    `${base}/cajas/asignar/${socioCajaId}`,
    payload,
    auth(token)
  );
  return data;
};

export const desasignarSocioCaja = async (
  cajaId: number,
  socioId: number,
  token: string
) => {
  debugger
  await axios.delete(
    `${base}/cajas/asignar/${socioId}/${cajaId}`,
    auth(token)
  );
};

export const obtenerPersonasDeCaja = async (cajaId: number, token: string) => {
  const { data } = await axios.get<CajaPersona[]>(
    `${base}/cajas/${cajaId}/personas`,
    auth(token)
  );
  return data;
};

export const crearPersonaCaja = async (
  cajaId: number,
  payload: Partial<CajaPersona>,
  token: string
) => {
  const { data } = await axios.post<CajaPersona>(
    `${base}/cajas/${cajaId}/personas`,
    payload,
    auth(token)
  );
  return data;
};

export const actualizarPersonaCaja = async (
  personaId: number,
  payload: Partial<CajaPersona>,
  token: string
) => {
  const { data } = await axios.put<CajaPersona>(
    `${base}/cajas/personas/${personaId}`,
    payload,
    auth(token)
  );
  return data;
};

export const eliminarPersonaCaja = async (personaId: number, token: string) => {
  await axios.delete(`${base}/cajas/personas/${personaId}`, auth(token));
};
